import React from 'react';

import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { Button } from '@/components/Buttons/Button';
import { Z_INDEX } from '@/constants/z-index';
import { useAppDispatch, useAppSelector } from '@/hooks/redux-hooks';
import { closeModal } from '@/slices/modalSlice';

const GlobalModal = () => {
  const dispatch = useAppDispatch();
  const { isOpen, content } = useAppSelector(state => state.modal);

  const handleClose = () => {
    dispatch(closeModal());
  };

  return (
    <Dialog
      aria-describedby='alert-dialog-description'
      aria-labelledby='alert-dialog-title'
      open={isOpen}
      scroll='paper'
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(18, 22, 63, 0.80)'
          }
        }
      }}
      sx={{ zIndex: Z_INDEX.priority }}
      onClose={handleClose}
    >
      <Box
        sx={{
          backgroundColor: '#070818',
          p: '24px',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          width: '590px',
          maxWidth: '100%',
          flex: 1
        }}
      >
        <DialogTitle sx={{ p: 0, lineHeight: 1 }}>{content?.title}</DialogTitle>
        <DialogContent
          sx={{
            p: 0,
            lineHeight: 1,
            overflow: 'visible'
          }}
        >
          {content?.body}
        </DialogContent>
        <DialogActions sx={{ py: 0, pl: 0, pr: '12px' }}>
          <Button
            sx={{ m: 0, width: 120 }}
            variant='contained'
            onClick={handleClose}
          >
            OK
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default GlobalModal;
